import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PaginatedLogs } from '../interfaces/paginated-log.interface';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Config } from '../app.configs';
import { CacheService } from './cache.service';

@Injectable({
  providedIn: 'root',
})
export class LogService {
  private readonly CACHE_PREFIX = 'logs:';

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private cacheService: CacheService,
  ) {}

  getLogs(
    uuid: string,
    page: number = 1,
    forceRefresh: boolean = false,
  ): Observable<PaginatedLogs> {
    const cacheKey = `${this.CACHE_PREFIX}${uuid}:${page}`;

    return this.cacheService.get<PaginatedLogs>(
      cacheKey,
      () => {
        const params = new HttpParams().set('page', page);
        const headers = this.authService.getHeaders();
        return this.http.get<PaginatedLogs>(
          Config.toApiUrl(`dashboard/users/${uuid}/logs/`),
          { headers, params, withCredentials: true },
        );
      },
      undefined,
      forceRefresh,
    );
  }

  invalidateLogsCache(uuid: string): void {
    this.cacheService.invalidateByPrefix(`${this.CACHE_PREFIX}${uuid}`);
  }
}
